import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useCustomerSubscriptions} from '../hooks/useCustomerSubscriptions.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useCustomerSubscriptions();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};

